/* Native links and forms remain functional without JavaScript. */
document.querySelectorAll('[data-sun-directory]').forEach((directory) => {
  const search = directory.querySelector('[data-sun-directory-search]');
  if (!search) return;
  const state = directory.querySelector('[data-sun-directory-state]');
  const cards = [...directory.querySelectorAll('[data-sun-place]')];
  const count = directory.querySelector('[data-sun-directory-count]');
  const empty = directory.querySelector('[data-sun-directory-empty]');
  const update = () => {
    const term = search.value.trim().toLocaleLowerCase();
    let visible = 0;
    cards.forEach((card) => {
      card.hidden = !card.dataset.search.includes(term) || (!!state.value && card.dataset.state !== state.value);
      if (!card.hidden) visible++;
    });
    count.textContent = `${visible} lake ${visible === 1 ? 'collection' : 'collections'}`;
    empty.hidden = visible > 0;
  };
  search.addEventListener('input', update);
  state.addEventListener('change', update);
  directory.querySelector('[data-sun-directory-reset]').addEventListener('click', () => {search.value = ''; state.value = ''; update(); search.focus();});
  update();
});
